import { render, staticRenderFns } from "./SdtdMap.vue?vue&type=template&id=0b37d1aa&"
import script from "./SdtdMap.vue?vue&type=script&lang=js&"
export * from "./SdtdMap.vue?vue&type=script&lang=js&"
import style0 from "./SdtdMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports